'use client';

import { EventData } from '../types';
import {
  getWindowTrackerState,
  serializeTrackingProps,
  setWindowTrackerState,
  TRACKER_ENABLED,
} from '../utils';
import { getUtag } from './utag';
import { logger } from '../utils';

/**
 * Sends given data as an event.
 */
export const trackEvent = async (data: EventData): Promise<void> => {
  return new Promise((resolve, reject) => {
    internalTrackEvent(data, resolve, reject);
  });
};

export const internalTrackEvent = (
  data: EventData,
  resolve: () => void,
  reject: (err: Error) => void,
): void => {
  if (!TRACKER_ENABLED) {
    logger.warn('Event not set. (Reason: Tracker disabled)');
    resolve();
    return;
  }

  if (!shouldQueue()) {
    let pageViewContext = getWindowTrackerState().pageViewContext;
    let serialized = serializeTrackingProps({
      ...data,
      ...pageViewContext,
    });

    let utag = getUtag(window);

    if (typeof utag === 'undefined') {
      resolve();
      logger.warn('Event not set. (Reason: Utag not ready.');
      return;
    }

    try {
      getUtag(window)?.link({ ...serialized });
      logger.log('Event: Sent.', serialized);
    } catch (e) {
      console.error('Could not send event to Utag.', e);
    }

    resolve();
    return;
  }

  logger.info('Event: Queued.', data);

  setWindowTrackerState(current => ({
    ...current,
    eventQueue: [
      ...current.eventQueue,
      {
        data,
        resolve,
        reject,
      },
    ],
  }));
};

const shouldQueue = () => {
  let {
    ready,
    meta: { pathname },
  } = getWindowTrackerState();

  if (!ready) {
    return true;
  }

  return pathname !== window.location.pathname;
};
